import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import MpdService from "../../services/mpd.service";

// **Async Thunks**
export const getDoc = createAsyncThunk(
  "mpd/getDoc",
  async (item, thunkApi) => {
    try {
      const response = await MpdService.getDoc(item);
      return response.data || []; 
    } catch (error) {
      return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const addDoc = createAsyncThunk(
  "mpd/addDoc",
  async (item, thunkAPI) => {
    try {
      const response = await MpdService.addDoc(item);
      return response.data || response.data; 
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const editDoc = createAsyncThunk(
  "mpd/editDoc",
  async (item, thunkAPI) => {
    try {
      const response = await MpdService.editDoc(item);
      return response.data || response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deleteDoc = createAsyncThunk(
  "mpd/deleteDoc",
  async (id, thunkAPI) => {
    try {
      await MpdService.deleteDoc(id);
      return id; // ✅ Return only the ID for state update
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const editGeneralInfo = createAsyncThunk(
  "mpd/editGeneralInfo",
  async (item, thunkAPI) => {
    try {
      const response = await MpdService.editGeneralInfo(item);
      return response.data || response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getGeneralInfo = createAsyncThunk(
  "mpd/getGeneralInfo",
  async (item, thunkApi) => {
    try {
      const response = await MpdService.getGeneralInfo(item);
      return response.data || []; 
    } catch (error) {
      return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const editStaff = createAsyncThunk(
  "mpd/editStaff",
  async (item, thunkAPI) => {
    try {
      const response = await MpdService.editStaff(item);
      return response.data || response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getStaff = createAsyncThunk(
  "mpd/getStaff",
  async (item, thunkApi) => {
    try {
      const response = await MpdService.getStaff(item);
      return response.data || []; 
    } catch (error) {
      return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const editInfrastructure = createAsyncThunk(
  "mpd/editInfrastructure",
  async (item, thunkAPI) => {
    try {
      const response = await MpdService.editInfrastructure(item);
      return response.data || response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getInfrastructure = createAsyncThunk(
  "mpd/getInfrastructure",
  async (item, thunkApi) => {
    try {
      const response = await MpdService.getInfrastructure(item);
      return response.data || []; 
    } catch (error) {
      return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const editAcademics = createAsyncThunk(
  "mpd/editAcademics",
  async (item, thunkAPI) => {
    try {
      const response = await MpdService.editAcademics(item);
      return response.data || response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getAcademics = createAsyncThunk(
  "mpd/getAcademics",
  async (item, thunkApi) => {
    try {
      const response = await MpdService.getAcademics(item);
      return response.data || []; 
    } catch (error) {
      return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// **Initial State**
const initialState = {
  loading: false,
  error: "",
  mpd: [],
};

// **Slice**
const mpdSlice = createSlice({
  name: "mpd",
  initialState,
  extraReducers: (builder) => {
    builder
      // **Handle Get Car Rental Package List**
      .addCase(getDoc.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getDoc.fulfilled, (state, action) => {
        state.loading = false;
        state.carrentalPackages = action.payload;
      })
      .addCase(getDoc.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Add Car Rental Package**
      .addCase(addDoc.pending, (state) => {
        state.loading = true;
      })
      .addCase(addDoc.fulfilled, (state, action) => {
        state.loading = false;
        state.carrentalPackages.push(action.payload);
      })
      .addCase(addDoc.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Edit Car Rental Package**
      .addCase(editDoc.pending, (state) => {
        state.loading = true;
      })
      .addCase(editDoc.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.carrentalPackages.findIndex((p) => p._id === action.payload._id); // ✅ Handle `_id` correctly
        if (index !== -1) {
          state.carrentalPackages[index] = action.payload;
        }
      })
      .addCase(editDoc.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Delete Car Rental Package**
      .addCase(deleteDoc.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteDoc.fulfilled, (state, action) => {
        state.loading = false;
        state.carrentalPackages = state.carrentalPackages.filter((p) => p._id !== action.payload); // ✅ Handle `_id`
      })
      .addCase(deleteDoc.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// **Export Reducer**
export default mpdSlice.reducer;
